import * as React from "react";
import { forwardRef } from "react";
const SvgPlusText = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 70, height: 30, viewBox: "0 0 70 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("text", { x: "50%", y: "50%", dominantBaseline: "central", textAnchor: "middle", fill: "#0C818F", fontFamily: "'Poppins', sans-serif", fontWeight: "bold", fontSize: 20 }, "PLUS"));
const ForwardRef = forwardRef(SvgPlusText);
export default ForwardRef;
